if (!customElements.get('sticky-quick-add')) {
  customElements.define('sticky-quick-add',
    class StickyQuickAdd extends HTMLElement {
      constructor() {
        super();

        this.mainProductButtons = document.querySelector('product-info .product-form__buttons');
        this.footer = document.querySelector('.shopify-section-group-footer-group');
        this.mainVariantSelectors = document.querySelector('product-info variant-radios') || document.querySelector('product-info variant-selects');
        this.footerVisible = false;
        this.buttonsVisible = false;
        this.variantAvailable = true;
      }

      connectedCallback() {
        this.setupObservers();
        // this.setupListeners();
        if (this.mainVariantSelectors) {
          this.mainVariantSelectors.addEventListener('change', this.onMainVariantSelectorsChange.bind(this));
        }
      }

      setupObservers() {
        const buttonObserverOptions = {
          root: null,
          rootMargin: '0px',
          threshold: 0,
        };
        const sectionObserverOptions = {
          root: null,
          rootMargin: '0px',
          threshold: 0,
        };
        const buttonObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.buttonsVisible = entry.isIntersecting;
            this.updateVisibility();
          });
        }, buttonObserverOptions);
        const footerObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.footerVisible = entry.isIntersecting;
            this.updateVisibility();
          });
        }, sectionObserverOptions);
        buttonObserver.observe(this.mainProductButtons);
        footerObserver.observe(this.footer);
      }

      setupListeners() {
        const radios = this.querySelectorAll('input[type="radio"]');
        if (radios.length > 0) {
          radios.forEach(radio => {
            radio.addEventListener('click', this.onRadioClick.bind(this));
          });
        }
      }

      onMainVariantSelectorsChange() {
        this.variantAvailable = this.mainVariantSelectors.currentVariant.available;
      }

      onRadioClick(e) {
        const selectedValue = e.currentTarget.value;
        const targetRadio = document.querySelector(`product-info variant-radios input[value="${selectedValue}"]`);
        targetRadio.checked = true;
      }

      updateVisibility() {
        if (!this.buttonsVisible && !this.footerVisible && this.variantAvailable) {
          this.setAttribute('data-shown', true);
        } else {
          this.setAttribute('data-shown', false);
        }
      }
    }
  )
};